module.exports = __webpack_public_path__ + "fonts/60be5c39-863e-40cb-9434-6ebafb62ab2b.d8c0392b.woff";